export class RestoreAzureSqlVmPitrRequest {
    'restoreAccountId';
    'vaultId';
    'restoreToTime';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreToTime",
            "baseName": "restoreToTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AzureVmInstanceRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureSqlVmPitrRequest.attributeTypeMap;
    }
    constructor() {
    }
}
